<template>
  <v-row>
    <v-col v-if="computedPedidos.length" cols="12" class="pb-0">
      <v-list
        class="pa-0"
        three-line
        :style="pedidosContainer"
      >
        <v-list-item
          v-for="(pedido, i) in computedPedidos"
          :key="i"
          @click="selectPedido(i)"
          :dark="isSelected(pedido.id_interno)"
          class="px-0"
          :class="{ 'selected': isSelected(pedido.id_interno) }"
        >
          <v-list-item-avatar class="d-flex flex-column justify-space-between" :class="$vuetify.breakpoint.xs ? 'ma-auto' : ''">
            <v-icon v-if="isSelected(pedido.id_interno)" color="white">mdi-check</v-icon>
            <StatusIcon v-else :status="pedido.status" />
            <input
              type="checkbox"
              v-model="computedPedidosSelected"
              ref="checkPedido"
              :value="pedido"
              style="display: none;"
            >
          </v-list-item-avatar>
          <v-list-item-content :class="i !== pedidos.length -1 ? 'pb-0' : ''">
            <v-col cols="10" md="4" class="pa-0">
              <v-list-item-title class="body-2 font-weight-bold">
                <v-icon small>mdi-store</v-icon>
                {{ pedido.cliente }}
              </v-list-item-title>
            </v-col>
            <v-col cols="12" md="4" offset-md="0" class="pa-0">
              <v-list-item-title class="caption">
                <v-icon small>mdi-calendar</v-icon>
                {{ pedido.data_emissao | dateMonthYear }}
              </v-list-item-title>
            </v-col>
            <v-col cols="10" md="4" class="pa-0">
              <v-list-item-title class="body-2">
                {{ pedido.total_produto | price }}
              </v-list-item-title>
            </v-col>
            <v-divider
              :key="i"
              class="mt-2"
            ></v-divider>
          </v-list-item-content>
          <v-list-item-action class="ma-auto">
            <v-btn icon @click.stop="$router.push(`/pedidos/${pedido.id_interno}`)">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <div class="text-center mt-1" id="listPedidosPagination">
        <v-pagination
          v-model="page"
          :length="totalPages"
          circle
        ></v-pagination>
      </div>
    </v-col>
    <v-col v-else cols="12">
      <p class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import StatusIcon from '@/components/shared/StatusIcon';
import { convertStringToCompare } from '@/helpers';

export default {
  name: 'ListPedidos',
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    page: 1,
    // timeout: null
  }),
  components: {
    StatusIcon
  },
  computed: {
    ...mapGetters(['pedidos', 'pedidosSelected']),
    computedPedidosSelected: {
      get() {
        return this.pedidosSelected;
      },
      set(value) {
        this.SET_PEDIDOS_SELECTED(value);
      }
    },
    pedidosContainer() {
      const offset = 80;
      const windowHeight = window.outerHeight;
      const paginationDiv = document.getElementById('listPedidosPagination');
      const paginationHeight = paginationDiv ? paginationDiv.innerHeight : 44;
      const pedidosContainerHeight = windowHeight - paginationHeight - offset;
      return {
        height: pedidosContainerHeight.toString() + 'px',
        overflow: 'auto'
      }
    },
    computedPedidos() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      let searchTerm = this.filters.search || '';
      searchTerm = convertStringToCompare(searchTerm);
      return this.pedidos
        .filter(pedido => convertStringToCompare(pedido.cliente).includes(searchTerm || ''))
        .slice(start, end)
        .sort((a, b) => a[this.filters.order] > b[this.filters.order] ? 1 : -1);
    },
    totalPages() {
      const total = this.pedidos.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
  methods: {
    ...mapMutations(['SET_PEDIDOS_SELECTED']),
    selectPedido(index) {
      this.$refs.checkPedido[index].click();
      this.$nextTick(() => this.$emit('pedidosSelected', this.computedPedidosSelected));
    },
    isSelected(id) {
      return !!this.computedPedidosSelected.find(pedido => pedido.id_interno == id);
    }
    // Hold to select
    // start(index) {
    //   if (!this.timeout) {
    //     this.timeout = setTimeout(() => this.selectPedido(index), 500);
    //   }
    // },
    // stop() {
    //   clearTimeout(this.timeout);
    //   this.timeout = null;
    // }
  }
}
</script>

<style scoped>
.selected {
  background-color: #1976d2;
}
</style>